import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HouseFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 25, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 25) / 25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4998 14.2012C10.4184 14.2012 8.7207 15.953 8.7207 18.1009V25.0003H16.2788V18.1009C16.2788 15.953 14.5812 14.2012 12.4998 14.2012Z"
        fill="currentColor"
      />
      <path
        d="M23.1395 6.68946L15 0.809935C13.5 -0.269978 11.4884 -0.269978 10 0.809935L1.86046 6.68946C0.697674 7.5294 0 8.90929 0 10.3732V20.5004C0 22.9842 1.95349 25 4.36046 25H6.97674V18.1006C6.97674 14.9568 9.45349 12.401 12.5 12.401C15.5465 12.401 18.0233 14.9568 18.0233 18.1006V25H20.6395C23.0465 25 25 22.9842 25 20.5004V10.3732C25 8.90929 24.3023 7.5294 23.1395 6.68946Z"
        fill="currentColor"
      />
    </svg>
  )
})

HouseFilled.displayName = 'HouseFilled'
